export type LinkGroup = {
  heading: string
  links: { label: string; href: string }[]
}

export const footerGroups: LinkGroup[] = [
  {
    heading: 'Face',
    links: [
      { label: 'Facelift', href: '#procedures' },
      { label: 'Rhinoplasty', href: '#procedures' },
      { label: 'Eyelid Surgery', href: '#procedures' },
      { label: 'Neck Lift', href: '#procedures' },
      { label: 'Brow Lift', href: '#procedures' },
    ],
  },
  {
    heading: 'Breast',
    links: [
      { label: 'Breast Augmentation', href: '#procedures' },
      { label: 'Breast Lift', href: '#procedures' },
      { label: 'Breast Reduction', href: '#procedures' },
      { label: 'Implant Revision', href: '#procedures' },
    ],
  },
  {
    heading: 'Body',
    links: [
      { label: 'Tummy Tuck', href: '#procedures' },
      { label: 'Brazilian Butt Lift', href: '#procedures' },
      { label: 'Liposuction', href: '#procedures' },
      { label: 'Mommy Makeover', href: '#procedures' },
      { label: 'Arm Lift', href: '#procedures' },
    ],
  },
  {
    heading: 'Med Spa',
    links: [
      { label: 'Botox & Dysport', href: '#med-spa' },
      { label: 'Lip Fillers', href: '#med-spa' },
      { label: 'Laser Hair Removal', href: '#med-spa' },
      { label: 'Medical Facials', href: '#med-spa' },
      { label: 'Skin Tightening', href: '#med-spa' },
    ],
  },
]

export const legalLinks = [
  { label: 'Privacy Policy', href: '#resources' },
  { label: 'Notice of Privacy Practices', href: '#resources' },
  { label: 'Terms of Use', href: '#resources' },
  { label: 'Accessibility', href: '#resources' },
]
